var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBack = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 7.569, height: 12 }, props, { children: _jsx("path", { "data-name": "Path 259", d: "M6.075 0 0 6.075l5.924 5.924 1.494-1.493-4.431-4.431 4.582-4.582Z", fillRule: "evenodd" }) }))); };
export default SvgBack;
